import { supabase } from '../lib/supabase';

export const authService = {
  async signUp(email, password, fullName) {
    const { data, error } = await supabase?.auth?.signUp({
      email,
      password,
      options: {
        data: {
          full_name: fullName,
          role: 'user'
        }
      }
    });
    if (error) throw error;
    return data;
  },

  async signIn(email, password) {
    const { data, error } = await supabase?.auth?.signInWithPassword({ 
      email, 
      password 
    });
    if (error) throw error;
    return data;
  },

  async signOut() {
    const { error } = await supabase?.auth?.signOut();
    if (error) throw error;
  },

  async getCurrentUser() {
    const { data: { user }, error } = await supabase?.auth?.getUser();
    if (error) throw error;
    return user;
  },

  async getUserProfile(userId) {
    const { data, error } = await supabase?.from('user_profiles')?.select('*')?.eq('id', userId)?.single();
    if (error) throw error;
    return data;
  },

  async isOwner() {
    try {
      const user = await this.getCurrentUser();
      if (!user) return false;
      
      // Double verification: Check both email and role
      const OWNER_EMAIL = 'infoedrianbass@gmail.com';
      if (user?.email?.toLowerCase() !== OWNER_EMAIL?.toLowerCase()) {
        return false;
      }
      
      const profile = await this.getUserProfile(user?.id);
      return profile?.role === 'owner' && profile?.is_active === true;
    } catch (error) {
      console.error('Owner check failed:', error);
      return false;
    }
  }
};